import { useEffect, useRef, useState } from "react";
import {
  GetTicketByIdApi,
  GetTicketChatApi,
  UpdateTicketApi,
} from "../../../../api/request/support";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Avatar, Input, Spin } from "antd";
import moment from "moment/moment.js";
import ConfirmationModal from "../../../../components/modals/ConfirmationModal";

export default function ViewTicket2() {
  const params = useParams();
  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--theme")
    ?.trim();
  const [isLoading, setIsLoading] = useState(false);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [ticket, setTicket] = useState(null);
  const [ticketChat, setTicketChat] = useState([]);
  const [message, setMessage] = useState("");
  const [closeTicketConfirmation, setCloseTicketConfirmation] = useState(false);
  const [isCloseTicketLoading, setIsCloseTicketLoading] = useState(false);
  const { userDetails } = useSelector((state) => state.user);
  const [lastSentMessage, setLastSentMessage] = useState(null);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
  messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
  }, [ticketChat, lastSentMessage]);

  const getTicket = async () => {
    try {
      setIsLoading(true);
      let apiParams = {
        TicketId: params?.ticketId,
      };
      const { data } = await GetTicketByIdApi(
        new URLSearchParams(apiParams).toString()
      );
      if (data?.success) {
        setTicket(data?.data);
        setIsLoading(false);
      }
      setIsLoading(false);
    } catch (error) { }
  };

  const closeTicketHandler = async () => {
    try {
      setIsCloseTicketLoading(true);
      let params = {
        TicketId: ticket?.ticketId,
        UserId: userDetails?._id,
        AdminComments: 'Closed by User',
        TicketStatusId: 3
      };
      const { data } = await UpdateTicketApi(params);
      if (data?.success) {
        setIsCloseTicketLoading(false);
        toast.success(data?.message);
        setCloseTicketConfirmation(false);
        getTicket();
      }
    } catch (error) {
      setIsCloseTicketLoading(false);
    }
  }

  const getTicketChat = async () => {
    setIsChatLoading(true);
    try {
      let apiParams = {
        ticketId: params?.ticketId,
        userComment: null,
        adminComment: null,
      };
      const { data } = await GetTicketChatApi(apiParams);
      if (data?.success) {
        setTicketChat(data?.data?.comments);
        setIsChatLoading(false);
      }
      setIsChatLoading(false);
    } catch (error) { }
  };

  const sendMessage = async () => {
    if (!message) {
      return;
    }
    try {
      let apiParams = {
        ticketId: params?.ticketId,
        userComments: message,
        adminComments: null,
      };
      const { data } = await GetTicketChatApi(apiParams);
      if (data?.success) {
        setMessage("");
        setTicketChat(data?.data?.comments);
        setLastSentMessage(message);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getTicket();
    getTicketChat();
  }, []);

  const getInitials = (name) => { 
    const nameParts = name.trim().split(' ');
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  };

  return (
    <>
    <div className="flex flex-col-reverse md:grid xl:grid-cols-12 md:grid-cols-12 xl:gap-7 gap-5">
      <div className="h-[calc(100vh-150px)] xl:col-span-8 md:col-span-6 flex flex-col mt-3">
        {isLoading || isChatLoading ? (
          <div className="flex justify-center flex-col mt-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <>    
            <div className=" flex-grow overflow-y-auto space-y-4">
            <ConfirmationModal
              isOpen={closeTicketConfirmation}
              setIsOpen={setCloseTicketConfirmation}
              message="Are you sure you want to close this ticket?"
              onConfirm={closeTicketHandler}
              isLoading={isCloseTicketLoading}
              loadingLabel="Closing ticket..."
            />
          <div className="">
            {ticketChat?.map((message, index) => {
              const isAdmin = userDetails?._id === message?.userId;

              return (
                <div key={index} className="" >
                  {isAdmin ? (
                    <div className="border-[1px] support_chatborder rounded-md py-4 w-full mt-3">
                      <div className="flex items-center justify-between px-4 lg:px-6 pb-2">
                        <div className="flex items-center">
                          <Avatar size={40} className="bg-primary uppercase" src={message?.profileImage}>
                            {getInitials("admin")}
                          </Avatar>
                          <p className="font-semibold text-base ml-2 text-[#2F2B3D]">
                            {message?.name}
                          </p>
                        </div>
                        <div>
                          <p className="text-gray-400 sm:text-sm text-xs">
                            {moment(message?.createdDate).format( "DD-MM-YYYY LT")}
                          </p>
                        </div>
                      </div>
                      <div className="h-auto overflow-y-auto">
                        <div className="px-4 lg:px-6">
                          <div className="flex w-full">
                            <p className="primary sm:text-base text-sm mt-2">
                              {message?.userComments}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="border-[1px] support_chatborder rounded-md py-4 w-full mt-3">
                      <div className="flex items-center justify-between px-4 lg:px-6 pb-2">
                        <div className="flex items-center">
                          <Avatar  size={40} className="bg-primary uppercase" src={message?.profileImage}>
                            {getInitials("Admin")}
                          </Avatar>
                          <p className="font-semibold text-base ml-2 text-[#2F2B3D]">
                            {message?.name}
                          </p>
                        </div>
                        <div>
                          <p className="text-gray-400 sm:text-sm text-xs">
                            {moment(message?.createdDate).format("DD-MM-YYYY LT")}
                          </p>
                        </div>
                      </div>
                      <div className="h-auto overflow-y-auto">
                        <div className="px-4 lg:px-6">
                          <div className="flex w-full">
                            <p className="primary sm:text-base text-sm mt-2">
                              {message?.adminComments}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div ref={messagesEndRef}></div>
          </div>
        </div>
          </>
        )}
        {ticket?.status === "Open" && (
          <div className="sticky bottom-4 px-1 py-1 mt-10">
            <Input
              className="transperant-input py-2 rounded-lg search-bar text-base w-full"
              placeholder="Type a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onPressEnter={sendMessage}
              suffix={
                <svg onClick={sendMessage} xmlns="http://www.w3.org/2000/svg" fill="#e5e5e5" viewBox="0 0 24 24" stroke-width="1.5" stroke={primaryColor} className="w-6 h-6 cursor-pointer duration-300" >
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                </svg>
              }
            />
          </div>
        )}
      </div>
      <div className="xl:col-span-4 border support_chatborder sm:p-5 p-3 md:col-span-6 rounded-md mt-5 h-[360px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
                <Avatar size={40} className="bg-primary uppercase" src={ticket?.profileImage}>
                  {getInitials("admin")}
                </Avatar>
                <p className="font-semibold text-base ml-2 text-[#2F2B3D]">
                  {ticket?.name}
                </p>
          </div>
           {ticket?.status === "Open" && (
              <button className="bg-gradient-red hover:bg-red-600 text-sm text-white font-medium px-6 py-2 rounded-lg duration-500 " onClick={() => setCloseTicketConfirmation(true)}>
                Close Ticket
              </button>
            )}
        </div>
          
         <div className="pt-6 pb-4 border-b support_chatborder flex flex-wrap justify-between items-center">
            <div className="flex flex-col sm:gap-2 gap-1">
                  <p className="text-[#2F2B3D] sm:text-xl text-lg font-semibold">
                    Ticket - #{ticket?.ticketNo}
                  </p>
                  <p className="primary sm:text-lg text-base font-semibold">
                    {ticket?.title}
                  </p>
            </div>
           
          </div>
          <div className="border-[1px] support_chatborder rounded-md px-4 lg:px-5 py-4 mt-5">
           <div className="flex items-center justify-end">
                <p className="text-gray-400 sm:text-sm text-xs pb-2">
                  {moment(ticket?.createdDate).format("DD-MM-YYYY LT")}
                </p>
              </div>
            <div className="h-auto overflow-y-auto">
                <div className="flex w-full">
                  <p className="primary sm:text-[15px] text-sm mt-2 line-clamp-4">
                    {ticket?.description}
                  </p>
                </div>
            </div>
            </div>
      </div>
    </div>
    </>
  );
}
